import type { MenuListResult } from "./model";
import request from "@/shared/api/request";

const Api = {
  LoginUserPermissions: "/saas/user/get-login-user-permissions",
};

export async function getMenuList(): Promise<MenuListResult> {
  const response = await request.get<{ menus: MenuListResult["list"]; permissions: string[] }>(
    Api.LoginUserPermissions,
  );

  return {
    list: response.data.menus,
    permissions: response.data.permissions,
  };
}
